import React from 'react';
import { useTranslation } from 'react-i18next';
import { colors, fonts, useMediaQuery } from '../../Styles';
import { EventNotePopover } from '..';

import { TestData as AnimalData } from '../../Assets/TestData/animalData';

interface Timeline_Props {
  selectedAnimal: number;
}
/**
 * Timeline
 * @param selectedAnimal 
 * @returns 
 */
export default function Timeline({ selectedAnimal }: Timeline_Props) {
  const {t} = useTranslation()
  const heightModal = useMediaQuery(`(max-height: 785px)`);
  const verticalModal = useMediaQuery(`(max-width: 690px)`);
  const horizontalModal = useMediaQuery(`(min-width: 690px) and (max-width: 740px), (min-width: 1000px) and (max-width: 1060px)`);
  
  const animal = AnimalData.find((animal) => animal.animalId === selectedAnimal);

  if (!animal || !animal.calendar) {
    return <p style={{...fonts.fontSize3, ...fonts.paragraph, color: colors.greyLightTertiary}}>{t("animalPages.animal.noTimeline")}</p>;
  }

  const eventColors = [
    colors.graphBlueOne,
    colors.graphBlueTwo,
    colors.graphBlueThree,
    colors.graphBlueFour,
    colors.graphBlueFive,
    colors.graphBlueSix,
    colors.graphBlueSeven,
    colors.graphBlueEight,
    colors.graphBlueNine,
    colors.graphBlueTen,
    colors.graphBlueEleven,
    colors.graphBlueTwelve
  ];  

  const timelineEvents = animal.calendar.sort((a, b) => a.date.getTime() - b.date.getTime());

  const startDate = timelineEvents[0].date;
  const endDate = timelineEvents[timelineEvents.length - 1].date;

  const totalDays = Math.max(
    1, // Ensure that totalDays is at least 1 to avoid division by zero
    Math.floor((endDate.getTime() - startDate.getTime()) / (1000 * 60 * 60 * 24))
  );

  // #region | Event Flag
  const renderTimelineEvents = () => {
    return timelineEvents.map((event, index) => {
      const daysDiff = Math.floor(
        (event.date.getTime() - startDate.getTime()) / (1000 * 60 * 60 * 24)
      );
      const relativePosition = (daysDiff / totalDays) * 100; 

      // Split date into day, month and year
      const dayMonth = event.date.toLocaleDateString('en-GB', { day: '2-digit', month: '2-digit' });
      const year = event.date.toLocaleDateString('en-GB', { year: 'numeric' });

      const backgroundColor = eventColors[index % eventColors.length];

      return (
        <div key={event.eventNo} style={{
          position: "absolute",
          bottom: verticalModal ? "unset" : (index % 2 === 0 ? "" : "30px"),
          top: verticalModal ? (`${relativePosition}%`) : (index % 2 === 0 ? "30px" : ""),
          left: verticalModal ? (index % 2 === 0 ? "" : "10px") : (`${relativePosition}%`),
          right: verticalModal ? (index % 2 === 0 ? "10px" : "") : "unset",
          borderLeft: verticalModal ? "none" : `3px solid ${backgroundColor}`,
          borderTop: verticalModal ? `3px solid ${backgroundColor}` : "none",
          padding: verticalModal ? "5px 0px 0px 0px" : "0px 0px 0px 5px",
          height: verticalModal ? "fit-content" : "130px",
          width: verticalModal ? "160px" : "fit-content",
          display: "flex",
          flexDirection: verticalModal ? (index % 2 === 0 ? "row-reverse" : "row") : (index % 2 === 0 ? "column" : "column-reverse"),
          gap: "5px"
        }}>
          <div style={{
            padding: "3px",
            background: `${backgroundColor}`,
            borderRadius: "5px",
            width: verticalModal ? "40px" : "50px",
            height: verticalModal ? "40px" : "50px",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center"
          }}>
            <p style={verticalModal ? {...fonts.fontSize4, ...fonts.header, color: colors.whitePrimary} : {...fonts.fontSize3, ...fonts.header, color: colors.whitePrimary} }>{dayMonth}</p>
            <p style={{ ...fonts.fontSize4, ...fonts.header, color: colors.whitePrimary }}>{year}</p>
          </div>
          <div style={{display: "flex", flexDirection: verticalModal ? "column" : (index % 2 === 0 ? "column" : "column-reverse"), gap: "5px", alignItems: verticalModal ? (index % 2 === 0 ? "end" : "start") : "start"}}>
            <div>
              <p style={{...fonts.fontSize4, ...fonts.header, color: (verticalModal||horizontalModal||heightModal) ? colors.greyDarkPrimary : colors.greyLightTertiary}}>{event.eventName}</p>
            </div>
            {event.note && (
              <EventNotePopover eventName={event.eventName} eventNote={event.note} glyphColor={(verticalModal||horizontalModal||heightModal) ? colors.greyDarkPrimary : colors.greyLightTertiary}/>
            )}
            </div>
        </div>
      );
    });
  }
  // #endregion

  return (
    <div style={{ display: "flex", alignItems: "center", justifyContent: "center", width: verticalModal ? "100%" : "80%", minWidth: verticalModal ? "300px" : (horizontalModal||heightModal) ? "550px" : "unset", padding: verticalModal ? "10px 0px" : (horizontalModal||heightModal) ? "0px 10px" : "0px"}}>
      <div style={{
        position: "relative",
        height: verticalModal ? "340px" : "300px",
        width: verticalModal ? "300px" : "100%",
        marginRight: verticalModal ? "0px" : "90px",
        marginBottom: verticalModal ? "90px" : "0px"
      }}>
        {/* Timeline line */}
        <div style={{
            position: 'absolute',
            top: verticalModal ? "0px" : '50%',
            left: verticalModal ? "50%" : "0px",
            bottom: verticalModal ? "-85px" : "unset",
            right: verticalModal ? "unset" : "-85px",
            // height: '800px',
            borderTop: verticalModal ? "none" : "2px dashed"+colors.greyDarkPrimary,
            borderLeft: verticalModal ? "2px dashed"+colors.greyDarkPrimary : "none"
        }}/>
        {/* Event flags */}
        {renderTimelineEvents()}
    </div>
    </div>
  );
}
